import React, { Component } from "react";
import { Auth } from "redux-server-connection";
import { withRouter } from "react-router-dom";
import httpStatusCodes from "http-status-codes";
import Render from "./Render";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { username: "", password: "", terms: false, error: false };
    this.bindings = {
      handleUsernameChange: this.handleUsernameChange.bind(this),
      handlePasswordChange: this.handlePasswordChange.bind(this),
      toggleTerms: this.toggleTerms.bind(this),
      submit: this.submit.bind(this)
    };
  }

  toggleTerms() {
    this.setState(state => {
      state.terms = !state.terms;
      return state;
    });
  }

  handleUsernameChange(e) {
    const val = e.target.value;
    this.setState(state => {
      state.username = val;
      return state;
    });
  }

  handlePasswordChange(e) {
    const val = e.target.value;
    this.setState(state => {
      state.password = val;
      return state;
    });
  }

  submit(e) {
    e.preventDefault();
    const credentials = {
      username: this.state.username,
      password: this.state.password,
      grant_type: "password",
      client_id: "1",
      client_secret: "123456",
      scope: ""
    };

    Auth.login(
      credentials,
      response => {
        if (response.status === httpStatusCodes.OK) {
          if (!Auth.getUser().avatar || Auth.getUser().avatar.name === "0") {
            this.props.history.push("/select-avatar");
          } else {
            this.props.history.push("/dashboard");
          }
        } else {
          this.setState({
            error: response.errors ? response.errors.message : response.error
          });
        }
      },
      this.endpoint
    );
  }

  render() {
    return <Render {...this.props} {...this.state} {...this.bindings} />;
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.js